export default "__VITE_ASSET__Cfisen08__"